import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core'

type CarouselDotsProps = {
  totalSlides: number
  activeSlide: number
  carouselRef: React.RefObject<any>
}

const useStyles = makeStyles((theme) =>
  createStyles({
    dotsContainer: {
      position: 'absolute',
      bottom: theme.spacing(3),
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: theme.spacing(1),
      zIndex: 100,
    },
    dot: {
      width: 40,
      height: 4,
      borderRadius: 2,
      border: 'none',
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      },
    },
    dotActive: {
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '0%',
        backgroundColor: theme.palette.common.white,
        borderRadius: 2,
        animation: '$progress 3s linear forwards',
      },
    },
    '@keyframes progress': {
      '0%': {
        width: '0%',
      },
      '100%': {
        width: '100%',
      },
    },
  })
)

const CarouselDots: React.FC<CarouselDotsProps> = ({
  totalSlides,
  activeSlide,
  carouselRef,
}) => {
  const classes = useStyles()

  const handleDotClick = (index: number) => {
    if (
      carouselRef.current &&
      typeof carouselRef.current.scrollItem === 'function'
    ) {
      carouselRef.current.scrollItem(index)
    } else {
      console.error('scrollItem method not available on carouselRef')
    }
  }

  return (
    <div className={classes.dotsContainer}>
      {Array.from({ length: totalSlides }, (_, index) => (
        <button
          key={`${index}-${activeSlide}`}
          className={`${classes.dot} ${
            index === activeSlide ? classes.dotActive : ''
          }`}
          onClick={() => handleDotClick(index)}
          aria-label={`Go to slide ${index + 1}`}
        />
      ))}
    </div>
  )
}

export default CarouselDots
